import { useParams } from "react-router-dom";
import { Breadcrumbs } from "../Breadcrumbs";
import { useWorkspaceStore } from "@/frontend/store/WorkspaceStore";
import { ProjectCards } from "../cards/ProjectCards";
import { useFusaOrganizationStore } from "@/frontend/store/FusaOrganizationStore";
import { useShallow } from "zustand/react/shallow";
import { useEffect, useState } from "react";
import { useProjectStore } from "@/frontend/store/ProjectStore";
import { CardPlaceholder } from "../cards/CardPlaceholder";
import { ProjectParentType } from "@/backend/models/project";

export function WorkspacePage() {
  const workspaceId = useParams().workspaceId;
  const workspace = useWorkspaceStore(useShallow(state => state.workspaces.find(workspace => workspace.id === workspaceId)));
  const projects = useProjectStore(useShallow(state => state.projects.filter(project => project.parentId === workspaceId)));
  const fusaOrganization = useFusaOrganizationStore(useShallow(state => state.fusaOrganizations.find(fusaOrganization => fusaOrganization.id === workspace?.ownerFusaOrgId)));
  const fetchProjectsForWorkspace = useProjectStore(state => state.fetchProjectsByParentId);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (workspaceId) {
      setLoading(true);
      void fetchProjectsForWorkspace(workspaceId).finally(() => {
        setLoading(false);
      });
    }
  }, [workspaceId, fetchProjectsForWorkspace]);

  if (loading) {
    return <CardPlaceholder />;
  }

  return (
    <div className="overflow-auto" style={{ maxHeight: '100vh', height: '100vh' }}>
      <Breadcrumbs items={[
        { title: fusaOrganization?.title ?? '', link: `/fusa-organizations/${fusaOrganization?.id}` },
      ]} />
      <div className="p-3">
        <div className="pb-3">
          <h1>{workspace?.title}</h1>
        </div>
        <ProjectCards projects={projects} parent={workspace} parentType={ProjectParentType.WORKSPACE} />
      </div>
    </div>
  );
}